export const LOAD_HEADER_EMERGENCY_DATA = 'LOAD_HEADER_EMERGENCY_DATA';
export const LOAD_HEADER_EMERGENCY_DATA_SUCCESS = 'LOAD_HEADER_EMERGENCY_DATA_SUCCESS';
export const LOAD_HEADER_EMERGENCY_DATA_ERROR = 'LOAD_HEADER_EMERGENCY_DATA_ERROR';
